import {Howl, Howler} from 'howler';
import Asset from './Asset';

export default class AudioAsset extends Asset {
    constructor(assetManager) {
        super(assetManager);
        this.type = "AUDIO";
        
        this.audio = null;
    }

    load(id, url, onLoad, onError) {
        this.id = id;
        let eventDispatched = false;

        const self = this;
        const internalOnLoad = function() {
            self.loaded = true;
            eventDispatched = true;
            if (onLoad)
                onLoad(self);
        };
        const internalOnError = function(error) {
            eventDispatched = true;
            if (onError)
                onError({
                    msg: error
                });
            else
                throw error;
        }

        this.audio = new Howl({
            src: [url],
            onload: internalOnLoad,
            onloaderror: internalOnError
        });
    }

    get() {
        return this.audio;
    }
}
